import isNull from 'lodash/isNull';
import {window} from 'ssr-window';
import {CHECKOUT_FETCH_RATES} from 'checkout/checkout-actions';
import CheckoutUtils from 'checkout/checkout-utils';
import {replace} from 'router/router-actions';
import SearchUtils from 'search/search-utils';
import {
    SEARCH_REQUEST_SET_TERM,
    SEARCH_REQUEST_UPDATE_TIMES
} from 'search-request/search-request-actions';
import {SPOT_CHANGE_MULTI_RATE} from 'spot/spot-actions';

export const searchRequestMiddleware = ({dispatch, getState}) => next => action => {
    switch (action.type) {
        case `${CHECKOUT_FETCH_RATES}_FULFILLED`: {
            const {
                searchRequest,
                checkout: {
                    rid
                }
            } = getState();
            const searchParams = {
                rid,
                ...searchRequest,
                ...action.meta
            };
            const newUrl = CheckoutUtils.updateRoute({
                currentUrl: (action.meta.newUrl)
                    ? action.meta.newUrl // RecommendedSpotsModal passes a new URL when a different spot is clicked so replace the url with this one
                    : window.location.pathname,
                searchParams
            });

            dispatch(replace(newUrl));

            break;
        }

        case SPOT_CHANGE_MULTI_RATE: {
            const searchParams = {
                ...getState().searchRequest,
                rid: action.payload.rid
            };
            const newUrl = CheckoutUtils.updateRoute({
                currentUrl: window.location.pathname,
                searchParams
            });

            dispatch(replace(newUrl));

            break;
        }

        case SEARCH_REQUEST_SET_TERM:
        case SEARCH_REQUEST_UPDATE_TIMES: {
            const {
                searchRequest,
                destination: {
                    data: {
                        airport,
                        monthly_enabled: monthlyEnabled = null,
                    }
                }
            } = getState();
            const pageType = searchRequest.pageType;
            const searchParams = {
                ...searchRequest,
                ...action.payload,
                monthlyEnabled,
                airport: Boolean(airport),
            };
            const newUrl = SearchUtils.updateRoute({
                currentUrl: window.location.pathname,
                searchParams
            });

            if (!isNull(pageType) && pageType !== 'home') {
                dispatch(replace(newUrl));
            }

            break;
        }
    }

    return next(action);
};
